export default __webpack_public_path__ + "static/media/AuthBackground.e3dd01a9.png";